import React from 'react';
import { useNavigate } from 'react-router-dom';
import { MobileListRenderItemInfo } from 'drf-react-by-schema';

import Card from '@mui/material/Card';
import Box from '@mui/material/Box';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';

import { Layout } from 'src/styles';
import CONSTANTS from 'src/constants/common';

import { useAppSelector } from 'src/app/hooks';
import { Perfil } from 'src/constants/Perfil';

import AsmubipButton from './AsmubipButton';
import ProductionChip from './ProductionChip';
import { ProductionKey } from 'src/constants';

export default function PerfilCard({ item, id }: MobileListRenderItemInfo) {
  const { key } = useAppSelector((state) => state.page);
  const navigate = useNavigate();
  if (!key) {
    return null;
  }
  return (
    <Card sx={Layout.mobileCard} variant="outlined">
      <CardContent
        sx={{
          ...Layout.productionCardContent,
          alignItems: 'flex-start',
          justifyContent: 'space-between',
        }}>
        <Box>
          <Box>
            {item.nome.valueStr}
            {item.apelido.value ? ` (${item.apelido.valueStr})` : ''}
          </Box>
          <Typography variant="body2">Perfil: {item.tipo.valueStr}</Typography>
          <Typography variant="body2">{item.grupo.valueStr}</Typography>
          <Typography variant="body2">{item.comunidade.valueStr}</Typography>
          {[Perfil.QUEBRADEIRA, Perfil.DIRECAO].includes(item.tipo.value.value) && (
            <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap', my: 1 }}>
              {item.azeite_production_total?.valueStr && (
                <ProductionChip
                  type={ProductionKey.AZEITE}
                  label={`${item.azeite_production_total.valueStr} Kg`}
                  onClick={() => {
                    navigate(`/azeite_production/?perfil=${id}`);
                  }}
                />
              )}
              {item.oleo_production_total?.valueStr && (
                <ProductionChip
                  type={ProductionKey.OLEO}
                  label={`${item.oleo_production_total.valueStr} Kg`}
                  onClick={() => {
                    navigate(`/oleo_production/?perfil=${id}`);
                  }}
                />
              )}
              {item.flocos_production_total?.valueStr && (
                <ProductionChip
                  type={ProductionKey.FLOCOS}
                  label={`${item.flocos_production_total.valueStr} Kg`}
                  onClick={() => {
                    navigate(`/flocos_production/?perfil=${id}`);
                  }}
                />
              )}
            </Box>
          )}
          <Typography variant="body2">
            Última atualização: {item.ultima_atualizacao.valueStr}
          </Typography>
        </Box>
        {item.foto.value && (
          <img
            src={`${CONSTANTS.API.url}/${item.foto.value.url}`}
            style={{ width: 120, height: 120, objectFit: 'cover', borderRadius: 10 }}
          />
        )}
      </CardContent>
      <CardActions>
        <Box sx={Layout.productionCardActionWrapper}>
          <AsmubipButton
            variant="outlined"
            size="medium"
            onClick={() => {
              navigate(`/${key}/view/${id}`);
            }}>
            Ver
          </AsmubipButton>
          <AsmubipButton
            variant="contained-dark"
            size="medium"
            onClick={() => {
              navigate(`/${key}/edit/${id}`);
            }}>
            Editar
          </AsmubipButton>
        </Box>
      </CardActions>
    </Card>
  );
}
